import React, { useState, useEffect } from 'react';
import { useForm } from "react-hook-form";
import {
    Link, Stack, Paper, TextField, Box, Grid, Typography, Card, TableCell, TableContainer,
    Table, InputAdornment, TableHead, Button, IconButton, FormControl, CardContent, DialogContent, DialogTitle, Dialog,
    InputLabel, TableRow, TableBody, Snackbar, CircularProgress, AccordionDetails, MenuItem, Checkbox, Autocomplete, Tooltip, Accordion, AccordionSummary
} from '@mui/material';
import { v4 as uuidv4 } from "uuid";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from '@iconify/react';
import axios from 'axios'
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import AddIcon from '@mui/icons-material/Add';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { BootstrapDialog, BootstrapDialogTitle } from '../../reusableComponent/BootstrapDialog'
import { ERPinput, ERPinputNo } from '../../reusableComponent/ErpTextField';
import { StyledTableCell, StyledTableRow } from '../../reusableComponent/StyledTable';
import { addProduction, addPurchaseOrder, editDeleteProduction, editDeletePurchaseOrder, getCNSList, getItemList, getTermsConditionsList, } from '../../../actions/actions';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import styles from '.././../../styles.module.css';
import { dateConversionOnEntryPage } from '../../reusableComponent/dateConversionOnEntryPage';
import { financialYear } from '../../reusableComponent/financialYear';
import { convertStringIntoTitleCase } from '../../reusableComponent/convertStringIntoTitleCase';
import { BackBtn, Cancel } from '../../reusableComponent/BackBtn';
import Breadcrumb from '../../reusableComponent/Breadcrumb';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';

const useStyles = makeStyles({
    option: {
        fontSize: 12,
    },
    noOptionsLabel: {
        fontSize: '12px', // Set the desired font size
    },
    // autocompletePaper: {
    //     border: 'none !important',
    //     boxShadow: 'none !important', 
    // },

});

function ProductionAdd(props) {
    // const editInfo = props.details;
    // const docNoFormateAvailable = props.docNoFormateAvailable;
    const urlLocation = useLocation();
    const prName = urlLocation.state.prName;
    const editInfo = urlLocation.state.row;
    const backBtnLen = urlLocation.state.backBtn;
    const docNoFormateAvailable = urlLocation.state.docNoFormateAvailable;
    const termsList = urlLocation.state.termsList;
    const dispatch = useDispatch();
    const classes = useStyles();
    const { handleSubmit } = useForm();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    const editData = editInfo && editInfo;
    const editid = editData ? editData.id : null;
    const [isUpdateArray, setIsUpdateArray] = useState(false);
    const [isUpdateArray2, setIsUpdateArray2] = useState(false);
    const currentDate = new Date().toISOString().substring(0, 10);
   
    const supplierList = useSelector(state => state.CNS.CNS)
    const itemList = useSelector(state => state.item.item)

    const [isSet, setIsSet] = useState(false);
    const [productionDate, setProductionDate] = React.useState(editData ? dayjs(editData.productionDate) : dayjs(new Date()));


    const [data, setData] = useState({
        id: editid,
        production_no: editData ? editData.production_no : '',
        remark: editData ? editData.remark : '',
    });


    //  FG good Items ------------

    const [inputFields, setInputFields] = useState(
        editData ? JSON.parse(editData.producedFGDetails) :
            [{
                id: uuidv4(),
                itemId: null,
                itemName: '',
                itemCode: '',
                producedQty: 0,
            },
            ]);

    const handleRemoveFields = (id) => {
        const values = [...inputFields];
        if (editData) {
            if (values.length > 1) {
                values.splice(
                    values.findIndex((value) => value.itemId === id),
                    1
                );
            }
        } else {
            values.splice(
                values.findIndex((value) => value.itemId === id),
                1
            );
        }

        setInputFields(values);
        setIsUpdateArray(isUpdateArray ? false : true);
    };
    const handleAddFields = () => {
        setInputFields([
            ...inputFields,
            {
                id: uuidv4(),
                itemCode: '',
                itemName: '',
                itemId: null,
                producedQty: 0,

            },
        ]);
    };

    const handleChangeItemDescription = (index) => (event, newValue) => {
        const updatedInputFields = inputFields.map((row, ind) => {
            if (ind === index) {

                return {
                    ...row,
                    itemId: newValue,
                    itemDescription: newValue ? newValue.itemDescription : null,
                    itemCode: newValue ? newValue.itemCode : null,
                    itemName: newValue ? newValue.itemName : null,
                    hsnCode: newValue ? newValue.hsnCode : null,
                };
            }
            return row;
        });

        setInputFields(updatedInputFields);
        setIsUpdateArray(!isUpdateArray);
    };

    const handleMultipleInput = (e, i) => {
        const array = inputFields;
        let result = array[i];

        result[e.target.name] = e.target.value;
        array[i] = result;

        setInputFields(array);
        setIsUpdateArray(isUpdateArray ? false : true);
    };

    //  FG Good Items End ------------

    // 
    const [inputFields2, setInputFields2] = useState(
        editData ? JSON.parse(editData.rawMaterialUsedDetails) :
            [{
                id: uuidv4(),
                itemId: null,
                itemName: '',
                itemCode: '',
                usedQty: 0,
            },
            ]);

    const handleRemoveFields2 = (id) => {
        const values = [...inputFields2];
        if (editData) {
            if (values.length > 1) {
                values.splice(
                    values.findIndex((value) => value.itemId === id),
                    1
                );
            }
        } else {
            values.splice(
                values.findIndex((value) => value.itemId === id),
                1
            );
        }

        setInputFields2(values);
        setIsUpdateArray2(isUpdateArray2 ? false : true);
    };
    const handleAddFields2 = () => {
        setInputFields2([
            ...inputFields2,
            {
                id: uuidv4(),
                itemCode: '',
                itemName: '',
                itemId: null,
                usedQty: 0,
            },
        ]);
    };

    const handleChangeItemDescription2 = (index) => (event, newValue) => {
        const updatedInputFields2 = inputFields2.map((row, ind) => {
            if (ind === index) {

                return {
                    ...row,
                    itemId: newValue,
                    itemDescription: newValue ? newValue.itemDescription : null,
                    itemCode: newValue ? newValue.itemCode : null,
                    itemName: newValue ? newValue.itemName : null,
                    hsnCode: newValue ? newValue.hsnCode : null,
                };
            }
            return row;
        });

        setInputFields2(updatedInputFields2);
        setIsUpdateArray2(!isUpdateArray2);
    };

    const handleMultipleInput2 = (e, i) => {
        const array = inputFields2;
        let result = array[i];

        result[e.target.name] = e.target.value;
        array[i] = result;

        setInputFields2(array);
        setIsUpdateArray2(isUpdateArray2 ? false : true);
    };

    // ------------    end ------
    const handleChangeProductionDate = (newValue) => {
        setProductionDate(newValue);
    };
    const handleChange = ({ target }) => {
        const value = target.value;
        setData({
            ...data,
            [target.name]: value,
        });
        data[target.name] = target.value;
        setIsSet(isSet ? false : true)

    }

    const supplierGetData = () => {
        dispatch(getCNSList({ financialYear: userInfo.financialYear, companyId: userInfo.companyId, CNS_Type: 'Supplier' }));
    }
    const itemGetData = () => {
        dispatch(getItemList({ companyId: userInfo.companyId }));
    }
    const [open, setOpen] = React.useState(false);
    const [options, setOptions] = React.useState([]);
    const loading = open && options.length === 0;

    React.useEffect(() => {
        if (!open) {
            setOptions([]);
        }
    }, [open]);

    const [successMessage, setSuccessMessage] = useState(null);
    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.production.message);

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);
        }
    }, [responseMessage, dispatch]);

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                if (responseMessage === 'Production already available!') {
                    setSuccessMessage(responseMessage)
                    setShouldShowMsg(false);
                    dispatch({ type: 'RESET_MESSAGE' });
                    setTimeout(() => {
                        setSuccessMessage(false)
                    }, 2000)

                } else {
                    setShouldShowMsg(true);
                    navigate(-1, { responseMessage });
                }
            }
        }
    }, [shouldShowMsg, responseMessage]);

    const onSubmit = (event) => {
      
        if (docNoFormateAvailable && docNoFormateAvailable.length === 0) {
            alert("Please enter Document No Format")
        } else {
            let productionData = {
                ...data,
                productionDate: dateConversionOnEntryPage(productionDate),
                producedFGDetails: inputFields,
                rawMaterialUsedDetails: inputFields2,
                companyId: userInfo.companyId,
                finYear: editData ? editData.finYear : financialYear(userInfo.financialYear, productionDate.$M, productionDate.$y),
                createdBy: editData ? editData.createdBy : userInfo.userId,
                createdAt: editData ? editData.createdAt : dateConversionOnEntryPage(new Date()),
                modifiedBy: editData ? userInfo.userId : null,
                modifiedAt: editData ? dateConversionOnEntryPage(new Date()) : '',
                changedUpdatedValue: 'edit',
            }

            if (editData) {
                dispatch(editDeleteProduction(productionData));
            } else {
                dispatch(addProduction(productionData));
            }
        }
        // }
    }

    useEffect(() => {
        supplierGetData()
        itemGetData()

        // if (editData) {
        //     const newArr = []
        //     JSON.parse(editData.producedFGDetails).map((row) => (
        //         newArr.push({
        //             itemId: row,
        //             itemCode: row.itemCode,
        //             itemId: row.itemId,
        //             itemName: row.itemName,
        //             quantity: row.quantity,

        //         })
        //     ))

        //     setInputFields(newArr)
        // }
        // if (editData) {
        //     const newArr2 = []
        //     JSON.parse(editData.rawMaterialUsedDetails).map((row) => (
        //         newArr2.push({
        //             itemId: row,
        //             itemCode: row.itemCode,
        //             itemId: row.itemId,
        //             itemName: row.itemName,
        //             quantity: row.quantity,

        //         })
        //     ))

        //     setInputFields2(newArr2)
        // }

    }, []);

    const navigate = useNavigate();

    return (
        <>
            <div>
                <Breadcrumb
                    routeSegments={[
                        { name: 'Production', path: '/production/' },
                        { name: 'Production List', path: '/production/production' },
                        { name: 'Create Production' },
                    ]}
                />
                <Paper className={`${styles.list_container}`} style={{ paddingLeft: '10px', paddingRight: '10px' }}>


                    <Box sx={{ m: 2 }} > </Box>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Box>
                            <Grid container spacing={0} sx={{ p: 0 }}>
                                <Grid item md={6}>

                                </Grid>
                                <Grid item md={6}>
                                    <Box >
                                        <Grid container spacing={1} >
                                            {editData ?
                                                <>
                                                    <Grid item xs={2}>
                                                        <Typography className={`${styles.erp_lable}`}>Production No</Typography>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <ERPinput
                                                            size='small'
                                                            fullWidth
                                                            name="production_no"
                                                            type="text"
                                                            onChange={handleChange}
                                                            value={data.production_no}
                                                        />
                                                    </Grid>
                                                </>
                                                :
                                                <>
                                                    <Grid item xs={2}>
                                                        <Typography className={`${styles.erp_lable}`}>Production No</Typography>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <div className={`${styles.skeleton_text}`}>
                                                            <Typography style={{ fontSize: '12px', padding: '1px 4px 1px 10px', color: '#707070' }}> </Typography>
                                                        </div>
                                                    </Grid>
                                                </>
                                            }
                                            <Grid item xs={2}>
                                                <Typography className={`${styles.erp_lable}`}> Production Date</Typography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DesktopDatePicker
                                                        name="productionDate"
                                                        inputFormat="DD/MM/YYYY"
                                                        value={productionDate}
                                                        onChange={handleChangeProductionDate}
                                                        renderInput={(params) => <ERPinput  {...params} size='small'
                                                            fullWidth />}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                        <br />
                        <Typography>Produced FG Deatails</Typography>
                        <TableContainer sx={{ overflowY: 'auto', minHeight: 120, maxHeight: 130 }}>
                            <Table sx={{ minWidth: 700, }} size='small' stickyHeader>
                                <TableHead >
                                    <StyledTableRow>
                                        <StyledTableCell align="left" className={`${styles.table_head}`} width="80%">
                                            Finished Good Name
                                        </StyledTableCell >
                                        <StyledTableCell align="right" className={`${styles.table_head}`}>Produced Quantity</StyledTableCell >
                                        <StyledTableCell align="right" className={`${styles.table_head}`}>Action</StyledTableCell >
                                    </StyledTableRow>
                                </TableHead >
                                <TableBody>
                                    {inputFields && inputFields.map((row, index) => (
                                        <StyledTableRow key={row.itemId} >
                                            <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                                                <Autocomplete
                                                    fullWidth
                                                    classes={{
                                                        option: classes.option,
                                                    }}
                                                    noOptionsText={
                                                        <span className={classes.noOptionsLabel}>No options</span>
                                                    }
                                                    options={itemList.filter(option => option.itemType === 'Finished Good')}
                                                    value={row.itemId}
                                                    onChange={handleChangeItemDescription(index)}
                                                    getOptionLabel={(option) => option.itemName + ' (' + option.itemCode + ')'}
                                                    getOptionSelected={(option, value) => option.id === value.id}
                                                    renderInput={(params) => <ERPinput required variant="standard"
                                                        InputProps={{
                                                            disableUnderline: true,
                                                        }}
                                                        {...params} />}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell align="right" className={`${styles.list_table_body}`}>
                                                <ERPinputNo
                                                    variant="standard"
                                                    required
                                                    type="number"
                                                    name="quantity"
                                                    value={row.quantity}
                                                    size='small'
                                                    onChange={(e) => handleMultipleInput(e, index)}
                                                    InputProps={{
                                                        disableUnderline: true,
                                                    }}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell align="right" className={`${styles.list_table_body}`} >
                                                <Box style={{ display: 'flex', justifyContent: 'center' }}>
                                                    <IconButton size="small" style={{ color: 'blue', fontSize: '14px' }} onClick={handleAddFields}>
                                                        <Icon icon="line-md:plus" />
                                                    </IconButton>
                                                    {index === 0 ?
                                                        <IconButton disabled size="small" sx={{ fontSize: '12px', color: 'red' }} >
                                                            <Icon icon={'line-md:remove'} />
                                                        </IconButton> :
                                                        <IconButton size="small" onClick={() => handleRemoveFields(row.id)} sx={{ fontSize: '12px', color: 'red' }}>
                                                            <Icon icon={'line-md:remove'} />
                                                        </IconButton>}
                                                </Box>
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <br />
                        <Typography>Raw Material Used</Typography>
                        <TableContainer sx={{ overflowY: 'auto', minHeight: 120, maxHeight: 130 }}>
                            <Table sx={{ minWidth: 700, }} size='small' stickyHeader>
                                <TableHead >
                                    <StyledTableRow>
                                        <StyledTableCell align="left" className={`${styles.table_head}`} width="80%">
                                            Raw Material Name
                                        </StyledTableCell >
                                        <StyledTableCell align="right" className={`${styles.table_head}`}>Used Quantity</StyledTableCell >
                                        <StyledTableCell align="right" className={`${styles.table_head}`}>Action</StyledTableCell >
                                    </StyledTableRow>
                                </TableHead >
                                <TableBody>
                                    {inputFields2 && inputFields2.map((row, index) => (
                                        <StyledTableRow key={row.itemId} >
                                            <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                                                <Autocomplete
                                                    fullWidth
                                                    classes={{
                                                        option: classes.option,
                                                    }}
                                                    noOptionsText={
                                                        <span className={classes.noOptionsLabel}>No options</span>
                                                    }
                                                    options={itemList.filter(option => option.itemType === 'Raw Material')}
                                                    value={row.itemId}
                                                    onChange={handleChangeItemDescription2(index)}
                                                    getOptionLabel={(option) => option.itemName + ' (' + option.itemCode + ')'}
                                                    getOptionSelected={(option, value) => option.id === value.id}
                                                    renderInput={(params) => <ERPinput required variant="standard"
                                                        InputProps={{
                                                            disableUnderline: true,
                                                        }}
                                                        {...params} />}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell align="right" className={`${styles.list_table_body}`}>
                                                <ERPinputNo
                                                    variant="standard"
                                                    required
                                                    type="number"
                                                    name="quantity"
                                                    value={row.quantity}
                                                    size='small'
                                                    onChange={(e) => handleMultipleInput2(e, index)}
                                                    InputProps={{
                                                        disableUnderline: true,
                                                    }}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell align="right" className={`${styles.list_table_body}`} >
                                                <Box style={{ display: 'flex', justifyContent: 'center' }}>
                                                    <IconButton size="small" style={{ color: 'blue', fontSize: '14px' }} onClick={handleAddFields2}>
                                                        <Icon icon="line-md:plus" />
                                                    </IconButton>
                                                    {index === 0 ?
                                                        <IconButton disabled size="small" sx={{ fontSize: '12px', color: 'red' }} >
                                                            <Icon icon={'line-md:remove'} />
                                                        </IconButton> :
                                                        <IconButton size="small" onClick={() => handleRemoveFields2(row.id)} sx={{ fontSize: '12px', color: 'red' }}>
                                                            <Icon icon={'line-md:remove'} />
                                                        </IconButton>}
                                                </Box>
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box >
                            <Grid container spacing={1} sx={{ mt: 1, }}>
                                <Grid item xs={12} md={12} >
                                    <Typography className={`${styles.erp_lable}`} sx={{ marginBottom: '8px' }}> Remarks</Typography>
                                    <ERPinput
                                        sx={{
                                            width: { sm: 100, md: 400 },
                                            "& .MuiInputBase-root": {
                                                height: 25,
                                                fontSize: 12
                                            }
                                        }}
                                        fullWidth
                                        type="text"
                                        name="remark"
                                        size='small'
                                        onChange={handleChange}
                                        value={(data.remark)}
                                    />
                                </Grid>
                            </Grid>
                            <Box sx={{ marginTop: '12px', float: 'right', }}>
                                <Button color="primary" id={`${styles.btn_save}`} variant="contained" type="submit">
                                    <SaveIcon style={{ fontSize: '16px', marginRight: '10px' }} />  {editData ? 'Update' : 'Save'}
                                </Button>
                                <Cancel />
                            </Box>
                        </Box>
                    </form>
                </Paper>
            </div>
            {successMessage &&
                <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    open={successMessage}
                    autoHideDuration={2000}
                    message={successMessage}
                />
            }
        </>
    )
}


export default ProductionAdd